import type { ComponentType, ReactNode } from 'react';
import React from 'react';

export default function withSuspense<T extends object>(
  Component: ComponentType<T>,
  fallback: ReactNode = null,
) {
  return function WithSuspense(props: T) {
    return (
      <React.Suspense fallback={fallback}>
        <Component {...props} />
      </React.Suspense>
    );
  };
}
